<template>
  <ButtonBase
    type="submit"
    :disabled="!form.isDirty"
    :processing="form.processing"
    ><CheckCircleIcon
      v-if="saved"
      class="-ml-2 mr-1.5 h-5 w-5 text-green-300"
    />{{ text }}</ButtonBase
  >
</template>

<script setup>
import ButtonBase from '@/Common/Elements/Buttons/ButtonBase.vue'
import { computed } from 'vue'
import { CheckCircleIcon } from '@heroicons/vue/solid'

const props = defineProps({
  form: Object,
})

const saved = computed(() => props.form.wasSuccessful && !props.form.isDirty)

const text = computed(() => (saved.value ? 'Saved' : 'Save'))
</script>
